module.exports = __webpack_public_path__ + "img/botSimplesmedicCorreto.fa5bdcfc.png";